import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { ICandidateRevenue, getCandidaterevenue, getJobById } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { AccessControl } from '../../../../../components';
import PotentialRevenue from '../../../../../features/jobs/listing/components/viewJd/potentialRevenue/PotentialRevenue';

interface ICandidateRevenueProps {
  candidateInteractionId: string;
  isPotentialRevenueTabVisible?: boolean | '';
}

const CandidateRevenue = ({
  candidateInteractionId,
  isPotentialRevenueTabVisible,
}: ICandidateRevenueProps) => {
  const [revenue, setRevenue] = useState<ICandidateRevenue>();

  useEffect(() => {
    const fetchData = async () => {
      const revenueResponse = await getCandidaterevenue(candidateInteractionId ?? '');
      const jobResponse = await getJobById(revenueResponse.data?.position?.id ?? '');
      const updateRevenueResp = {
        ...revenueResponse.data,
        jobDuration: jobResponse.data.workDuration,
        jobDurationTimeSpan: jobResponse.data.workDurationTimeSpan,
      };
      setRevenue(updateRevenueResp);
    };
    fetchData();
  }, [candidateInteractionId]);

  return isPotentialRevenueTabVisible ? (
    <Grid
      container
      xs={12}
      sx={{ background: WsColors.White, paddingLeft: '10%' }}
      p={1}
      display="flex"
      justifyContent="flex-end"
    >
      <PotentialRevenue candidateRevenueInfo={revenue} />
    </Grid>
  ) : (
    <AccessControl />
  );
};

export default CandidateRevenue;
